module.exports = __webpack_public_path__ + "static/set-app-name-a12b59fd9b3031d82956025af7b560a7.png";